var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSoundOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_sound_on_svg__a",
  x1: 2.056,
  y1: 5.631,
  x2: 26.623,
  y2: 22.833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0641a0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#0641a0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#4b3d9e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#8b399b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#c13599"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ef3197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#f3308a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#e83174"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#dd305a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#d13141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cb3136"
})))), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  style: {
    fill: "#333"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.532 17.15a.499.499 0 0 1-.683-.185.5.5 0 0 1 .185-.683c.458-.263.743-.755.743-1.282s-.285-1.02-.743-1.282a.5.5 0 0 1 .498-.867A2.485 2.485 0 0 1 21.777 15c0 .883-.476 1.706-1.245 2.149Zm3.15-2.15a4.874 4.874 0 0 0-2.198-4.08.5.5 0 1 0-.55.834c1.094.723 1.747 1.936 1.747 3.246s-.653 2.524-1.748 3.246a.5.5 0 1 0 .551.834A4.874 4.874 0 0 0 23.681 15Zm-1.298-6.064a.5.5 0 1 0-.582.813A6.478 6.478 0 0 1 24.5 15a6.481 6.481 0 0 1-2.699 5.252.5.5 0 1 0 .583.813A7.483 7.483 0 0 0 25.5 15a7.479 7.479 0 0 0-3.116-6.064Zm-4.304-.17v12.468a.94.94 0 0 1-.469.82.952.952 0 0 1-.481.133.948.948 0 0 1-.462-.122L12 19.47H7a2.502 2.502 0 0 1-2.5-2.5v-3.942c0-1.378 1.12-2.5 2.5-2.5h5l4.668-2.594a.946.946 0 0 1 .943.011.94.94 0 0 1 .469.82ZM7 18.47h4.629v-6.942h-4.63c-.826 0-1.5.673-1.5 1.5v3.942c0 .827.674 1.5 1.5 1.5Zm10.154 2.72L17.08 8.766l-4.451 2.553v7.358l4.525 2.514Z",
  style: {
    fill: "url(#icon_sound_on_svg__a)"
  }
}));
export default SvgIconSoundOn;